import { Flex, Modal } from 'antd';
import { pinwheel } from 'ldrs'
import { useEffect, useState } from 'react';

pinwheel.register()

const Loader = ({onOk}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsModalOpen(true);
    }, 5000);
    return () => clearTimeout(timeout);
  }, []);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const style = {
    width: '100vw',
    height: '100vh',
    backgroundColor: '#171717',
    position:'absolute',
    left: 0,
    top: 0,
    zIndex:999
  };

  return (
    <Flex vertical style={style} align='center' justify='center' >
      <Modal title='Switch to static' open={isModalOpen} onCancel={handleCancel} onOk={onOk} >
        <p>The 3D Room is taking a while to load, if you would like to switch to the static room click on the 'OK' button</p>
      </Modal>
      <l-pinwheel
        size="100"
        stroke="13"
        speed="0.9" 
        color="#D86ECC" 
      ></l-pinwheel>
    </Flex>
  );
};

export default Loader;